import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import {
  getGetBillingInvoicesQueryKey,
  getGetBillingShopsQueryKey,
  getGetBillingSummaryQueryKey,
  getGetCommissionsQueryKey,
} from "@/api";

export type BillingCallbackStatus = "success" | "failed" | undefined;

// The backend verifies the gateway payment, then redirects here with ?status=.
export function useBillingCallbackPage(status: BillingCallbackStatus) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const isSuccess = status === "success";

  useEffect(() => {
    if (!isSuccess) return;
    for (const queryKey of [
      getGetBillingShopsQueryKey(),
      getGetBillingSummaryQueryKey(),
      getGetCommissionsQueryKey(),
      getGetBillingInvoicesQueryKey(),
    ]) {
      void queryClient.invalidateQueries({ queryKey: queryKey.slice(0, 1) });
    }
    const timer = setTimeout(() => {
      void navigate({ to: "/billing" });
    }, 3000);
    return () => clearTimeout(timer);
  }, [isSuccess, navigate, queryClient]);

  return {
    isLoading: status === undefined,
    isError: status === "failed",
    isSuccess,
    onGoToBilling: () => void navigate({ to: "/billing" }),
    onGoToDashboard: () => void navigate({ to: "/" }),
  };
}
